import type { Result } from "true-myth/result"

export { err as Err, ok as Ok } from "true-myth/result"
export type { Result } from "true-myth/result"

/**
 * Unwrap a `Result` by returning its value on success or throwing an `Error`
 * on failure. The thrown `Error` carries the original `Result` error as its
 * `cause` so callers can still inspect the typed `ApiError` / domain error.
 */
export function unwrapOrThrow<T, E extends { message: string }>(result: Result<T, E>): T {
  if (result.isErr) {
    throw new Error(result.error.message, { cause: result.error })
  }
  return result.value
}
